export const environment = {
  appName: 'compat',
  environmentName: 'prod',
  production: true,
  useFakes: false,
  authConfig: {
    baseUrl: 'https://www.freelancer.com/auth',
    switchAccountHackyEndpoint:
      'https://www.freelancer.com/ajax-api/navigation/switchaccount.php',
    authHashCookie: 'GETAFREE_AUTH_HASH_V2',
    userIdCookie: 'GETAFREE_USER_ID',
    csrfCookie: 'XSRF-TOKEN',
    euCookie: 'is_from_eu',
    gdprCookie: 'requires_gdpr',
    authHeaderName: 'freelancer-auth-v2',
    referralCookie: 'referral_signup',
  },
  captchaConfig: {
    recaptchaPublicKey: '6Lc1CCcTAAAAABxlulYmWJj_ZNAHHegrhLV3vS2Z',
  },
  appsDomainsMap: {
    admin: {
      en: 'www.freelancer.com',
    },
    main: {
      en: 'www.freelancer.com',
      'en-AU': 'www.freelancer.com.au',
      'en-NZ': 'www.freelancer.co.nz',
      'en-GB': 'www.freelancer.co.uk',
      zh: 'www.freelancer.hk',
      'zh-HK': 'www.freelancer.hk',
      'en-SG': 'www.freelancer.sg',
      'en-PH': 'www.freelancer.ph',
      de: 'www.freelancer.de',
      'de-DE': 'www.freelancer.de',
      'en-CA': 'www.freelancer.ca',
      'en-ZA': 'www.freelancer.co.za',
      'en-IN': 'www.freelancer.in',
      'en-JM': 'www.freelancer.com.jm',
      es: 'www.freelancer.es',
      'es-ES': 'www.freelancer.es',
      'es-MX': 'www.freelancer.mx',
      'es-PE': 'www.freelancer.com.pe',
      'es-EC': 'www.freelancer.ec',
      'es-CL': 'www.freelancer.cl',
      'en-PK': 'www.freelancer.pk',
      id: 'www.freelancer.co.id',
      'id-ID': 'www.freelancer.co.id',
      'en-BD': 'www.freelancer.com.bd',
      'es-UY': 'www.freelancer.uy',
      pt: 'www.freelancer.pt',
      'pt-PT': 'www.freelancer.pt',
      ro: 'www.freelancer.co.ro',
      'ro-RO': 'www.freelancer.co.ro',
      ru: 'www.freelancer.com.ru',
      'ru-RU': 'www.freelancer.com.ru',
      'zh-CN': 'www.freelancer.cn',
      ja: 'www.freelancer.jp',
      'ja-JP': 'www.freelancer.jp',
      el: 'www.freelancer.gr',
      'el-GR': 'www.freelancer.gr',
      'en-IS': 'www.freelancer.is',
      th: 'www.freelancer.co.th',
      'th-TH': 'www.freelancer.co.th',
      cs: 'www.freelancer.cz',
      'cs-CZ': 'www.freelancer.cz',
      'pt-BR': 'www.br.freelancer.com',
      'es-AR': 'www.freelancer.com.ar',
      'es-CO': 'www.freelancer.com.co',
      pl: 'www.freelancer.pl',
      'pl-PL': 'www.freelancer.pl',
      uk: 'www.freelancer.com.ua',
      'uk-UA': 'www.freelancer.com.ua',
      nb: 'www.freelancer.no',
      'nb-NO': 'www.freelancer.no',
      ko: 'www.freelancer.co.kr',
      'ko-KR': 'www.freelancer.co.kr',
      'en-IE': 'www.freelancer.ie',
      fr: 'www.fr.freelancer.com',
      'fr-FR': 'www.fr.freelancer.com',
      it: 'www.freelancer.co.it',
      'it-IT': 'www.freelancer.co.it',
      sl: 'www.freelancer.si',
      'sl-SI': 'www.freelancer.si',
      sv: 'www.freelancer.se',
      'sv-SE': 'www.freelancer.se',
      fi: 'www.fi.freelancer.com',
      'fi-FI': 'www.fi.freelancer.com',
      da: 'www.dk.freelancer.com',
      'da-DK': 'www.dk.freelancer.com',
      ms: 'www.my.freelancer.com',
      'ms-MY': 'www.my.freelancer.com',
      tr: 'www.tr.freelancer.com',
      'tr-TR': 'www.tr.freelancer.com',
      vi: 'www.vn.freelancer.com',
      'vi-VN': 'www.vn.freelancer.com',
      sw: 'www.freelancer.co.ke',
      'sw-KE': 'www.freelancer.co.ke',
      sq: 'www.freelancer.com.al',
      'sq-AL': 'www.freelancer.com.al',
      hu: 'www.freelancer.hu',
      'hu-HU': 'www.freelancer.hu',
      af: 'www.freelancer.com',
      bn: 'www.freelancer.com',
      ca: 'www.freelancer.com',
      fil: 'www.freelancer.com',
      hi: 'www.freelancer.com',
      nl: 'www.freelancer.com',
    },
    developers: {
      en: 'developers-shadow.freelancer.com',
    },
    bits: {
      en: 'bits.freelancer.com',
    },
    arrow: {
      en: 'freelancer.arrow.com',
      fr: 'freelancer.arrow.com',
      de: 'freelancer.arrow.com',
      es: 'freelancer.arrow.com',
      it: 'freelancer.arrow.com',
      ko: 'freelancer.arrow.com',
      zh: 'freelancer.arrow.com',
    },
  },
  uiConfig: {
    assetsBaseUrl: 'https://www.f-cdn.com/assets/compat/de/assets',
    locale: 'de',
  },
  mapsConfig: {
    apiKey: 'AIzaSyAWB_zZMjdwNlu8-9xZ8RyNRbCERQTWSR8',
    libraries: ['places'],
  },
  datastoreConfig: {
    webSocketUrl: 'https://notifications.freelancer.com',
    enableStoreFreeze: false,
  },
  freelancerHttpConfig: {
    baseUrl: 'https://www.freelancer.com',
    apiBaseUrl: 'https://www.freelancer.com/api',
    ajaxBaseUrl: 'https://www.freelancer.com/ajax-api',
    authBaseUrl: 'https://www.freelancer.com/auth',
  },
  threatmetrixConfig: {
    baseUrl: 'https://cdn1.f-cdn.com',
    orgId: 'lar9e74p',
  },
  trackingConfig: {
    trackingEndpoint: 'https://t.freelancer.com/0px.gif',
    sessionCookie: '_tracking_session',
    navigationPerformanceSamplingRate: 1,
    enableErrorTracking: true,
    sentryDsn: 'https://29cfb544702b48e0985e69cd3ef5e84f@sentry.io/1410063',
    gitRevision: 'dfc7d2eeaf4b49160765a80e7f862d52c96cdeee',
    buildTimestamp: 1578270674089,
    gaTrackingId: 'UA-223765-6',
    awGoogleConversionId: undefined,
    facebookPixelId: 530993107478103,
  },
  billingConfig: {
    baseUrl: 'https://api.freelancerbilling.com',
  },
  facebookConfig: {
    appId: '120131118061981',
  },
  languageCookie: 'GETAFREE_LANGUAGE',
  linkTags: {
    publisherUrl: {
      rel: 'publisher',
      href: 'http://plus.google.com/+Freelancer',
    },
    sameAsUrl: {
      itemprop: 'sameAs',
      href: 'http://en.wikipedia.org/wiki/Freelancer.com',
    },
    rssUrl: {
      rel: 'alternative',
      type: 'application/rss+xml',
      title: 'Latest Projects',
      href: 'https://www.freelancer.com/rss.xml',
    },
  },
  whitelistCookie: 'IS_WHITELIST_USER',
  siteName: 'Freelancer',
};
